import { useEffect, useState } from "react";

export function MobileWarning() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768); // or use user-agent if preferred
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  if (!isMobile) return null;

  return (
    <div style={{
      position: "fixed",
      top: 0,
      width: "100%",
      background: "#fffbe6",
      padding: "10px",
      zIndex: 1000,
      textAlign: "center",
      fontWeight: "bold",
      borderBottom: "1px solid #ddd"
    }}>
      Heads up! This site is best viewed on a desktop or laptop.
    </div>
  );
}
